import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { ApiKeyCreationDialogue } from './api-key-confirmation-dialogue/api-key-confirmation-dialogue.component';
import { ApiKeysDialoguesService } from './api-keys-dialogues.service';
import { CreateApiKeyForm } from './create-api-key-form/create-api-key-form.component';

@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        SharedUiModule,
        NgxLoadingModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        ButtonsModule,
        FlyFreelyTableModule,
        ModalModule.forChild(),
        EnhancedHelpModule,
        AnalyticsModule
    ],
    providers: [ApiKeysDialoguesService],
    declarations: [CreateApiKeyForm, ApiKeyCreationDialogue],
    exports: [CreateApiKeyForm, ApiKeyCreationDialogue]
})
export class ApiKeysModule {}
